var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSvg172(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3374_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.385886 8.89222C0.385468 10.4046 0.780631 11.8813 1.53203 13.1828L0.314026 17.63L4.8651 16.4367C6.12387 17.1219 7.53422 17.481 8.96742 17.4811H8.97119C13.7025 17.4811 17.5538 13.6311 17.5559 8.89899C17.5568 6.60594 16.6646 4.44971 15.0436 2.82748C13.4229 1.20538 11.2674 0.311593 8.97084 0.310547C4.239 0.310547 0.38791 4.16031 0.385956 8.89222",
    fill: "url(#paint0_linear_3374_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.0794119 8.88949C0.0789235 10.4563 0.488249 11.9858 1.26644 13.334L0.00476074 17.9405L4.71902 16.7044C6.01795 17.4126 7.48041 17.786 8.96855 17.7866H8.97239C13.8734 17.7866 17.8631 13.7981 17.8652 8.8966C17.8661 6.52116 16.9418 4.28742 15.2629 2.60707C13.5838 0.92693 11.3512 0.000976744 8.97239 0C4.07053 0 0.0813654 3.98791 0.0794119 8.88949ZM2.88692 13.1018L2.7109 12.8223C1.97095 11.6458 1.58039 10.2862 1.58095 8.89005C1.58248 4.81598 4.89811 1.5014 8.97518 1.5014C10.9496 1.50223 12.8051 2.27191 14.2008 3.66837C15.5963 5.06498 16.3643 6.92149 16.3638 8.89605C16.3619 12.9701 13.0462 16.2851 8.97239 16.2851H8.96946C7.64297 16.2844 6.34202 15.9282 5.20746 15.255L4.93746 15.0949L2.13992 15.8284L2.88692 13.1018Z",
    fill: "url(#paint1_linear_3374_104)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74972 5.17316C6.58326 4.80318 6.40807 4.79572 6.24977 4.78923C6.12014 4.78365 5.97195 4.78406 5.82391 4.78406C5.67572 4.78406 5.43495 4.83981 5.23144 5.06202C5.02772 5.28444 4.45367 5.82193 4.45367 6.91511C4.45367 8.0083 5.24993 9.06486 5.36093 9.21325C5.47207 9.36137 6.89812 11.6765 9.15663 12.5672C11.0337 13.3073 11.4156 13.1601 11.823 13.123C12.2304 13.086 13.1377 12.5857 13.3228 12.0668C13.508 11.548 13.508 11.1033 13.4525 11.0104C13.397 10.9178 13.2488 10.8622 13.0266 10.7511C12.8043 10.6401 11.7119 10.1024 11.5082 10.0283C11.3045 9.95418 11.1564 9.9172 11.0082 10.1397C10.86 10.3618 10.4345 10.8622 10.3048 11.0104C10.1752 11.1589 10.0455 11.1774 9.82339 11.0663C9.60105 10.9548 8.88544 10.7204 8.03644 9.96353C7.37588 9.37455 6.92993 8.64723 6.8003 8.42474C6.67067 8.2026 6.78642 8.08218 6.89784 7.97146C6.99767 7.8719 7.12012 7.712 7.23133 7.5823C7.34212 7.45253 7.37909 7.35995 7.45319 7.21176C7.52735 7.06344 7.49023 6.93367 7.43477 6.82253C7.37909 6.71139 6.9473 5.61248 6.74972 5.17316Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3374_104",
    x1: 8.93495,
    y1: 17.63,
    x2: 8.93495,
    y2: 0.310547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1FAF38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#60D669"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3374_104",
    x1: 8.93499,
    y1: 17.9405,
    x2: 8.93499,
    y2: 0,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3374_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.87,
    height: 18,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSvg172);
export default __webpack_public_path__ + "static/media/svg172.108a78d24d2c857074bee12bac756417.svg";
export { ForwardRef as ReactComponent };